import { Controller } from "@hotwired/stimulus";
import Avatar from "avatar-initials";

// Connects to data-controller="suitical"
export default class extends Controller {
  static targets = ["avatar"];

  connect() {
    document.documentElement.style.setProperty("--company-primary-color", "#F1884E");
    document.documentElement.style.setProperty("--bs-primary-rgb", "241, 136, 78");
    document.documentElement.style.setProperty("--company-dark-color", "#EB622D");
    document.documentElement.style.setProperty("--company-primary-color-darker", "#F1864D");
    document.documentElement.style.setProperty("--company-light-color", "#009C94");
    document.documentElement.style.setProperty("--company-x-light-color", "#009c947a");
    document.documentElement.style.setProperty("--company-primary-gradient-color", "#FF8A49");
    document.documentElement.style.setProperty("--company-secondary-gradient-color", "transparent");
    document.documentElement.style.setProperty("--company-complemenatary-color", "#EB622D");
    document.documentElement.style.setProperty("--company-muted-color", "#F5E4DA");
    document.documentElement.style.setProperty("--company-light-color", "#f1874e2b");
  }

  avatarTargetConnected(element) {
    const initials = element.dataset.initials;
    Avatar.from(this.avatarTarget, {
      useGravatar: false,
      initials: initials,
      color: "white",
      background: '#F1884E',
      fontWeight: 100,
      fontFamily: "'Raleway', 'Lato', 'Lato-Regular', 'Helvetica Neue'",
      fontSize: 18,
      width: 50,
      height: 50,
    });
  }
}
